import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
} from '@common/utils/validation/constants'
import { TokenPermission } from '@data/rbac/model/rbac'
import { JwtPayloadCustom } from '@projtypes/token'
import { jwtDecode } from 'jwt-decode'

export const AUTH_TOKEN_EXPIRY_CLOCK_SKEW_SECONDS = 30

export const validateEmailStructure = (email: string) => {
  return EMAIL_REGEX.test(String(email).toLowerCase())
}

export const validatePasswordStructure = (password: string): boolean => {
  return PASSWORD_REGEX.test(password)
}

export const hasPermissions = (permissions: TokenPermission[], requiredPermissions: string[]) => {
  // Test if user is assigned correct permission in the requiredPermissions array
  // Permission in the array seperated by '||' are handled as an OR case eg, ['role1||role2', role3], User must have (role1 OR role2) AND role 3
  return (
    requiredPermissions.length === 0 ||
    requiredPermissions.every((e) => {
      let authorized: boolean
      const permissionNames = permissions.map((p) => p.name)
      const arrayOfPermissions = e.split('||')
      if (arrayOfPermissions.length > 1) {
        // User must have at least 1 of the permissions present in arrayOfPermissions
        authorized = arrayOfPermissions.some((p) => permissionNames.includes(p))
      } else {
        // User must have this permission
        authorized = permissionNames.includes(e)
      }
      return authorized
    })
  )
}

export const decodeJWT = (token: string): JwtPayloadCustom => {
  return jwtDecode(token)
}

export const decodeInviteTokenSafely = (token?: string): JwtPayloadCustom | null => {
  if (!token) {
    return null
  }

  try {
    return decodeJWT(token)
  } catch {
    return null
  }
}

export const isJWTFresh = (
  token: string,
  clockSkewSeconds = AUTH_TOKEN_EXPIRY_CLOCK_SKEW_SECONDS,
): boolean => {
  try {
    const decoded = decodeJWT(token)

    if (typeof decoded.exp !== 'number') {
      return false
    }

    return decoded.exp > (Date.now() / 1000) + clockSkewSeconds
  } catch {
    return false
  }
}
